if (!customElements.get('gma-free-shipping')) {
  customElements.define(
    'gma-free-shipping',
    class GmaFreeShipping extends HTMLElement {
      connectedCallback() {
        this.teardownInteractions();

        this.bubbleEl = this.querySelector('[data-gma-free-shipping-bubble]');
        this.bubbleImg = this.querySelector('[data-gma-bubble-img]');
        this.bubbleTextEl = this.querySelector('[data-gma-free-shipping-bubble-text]');
        this.goalEl = this.querySelector('[data-gma-free-shipping-goal]');
        this.passerEl = this.querySelector('[data-gma-free-shipping-passer]');
        this.passerReverseEl = this.querySelector('[data-gma-free-shipping-passer-reverse]');
        this.passerColors = [
          { fill: '#ffffff', stroke: '#3a6758' },
          { fill: '#e6d9a8', stroke: '#6b5a30' },
          { fill: '#e0b8ac', stroke: '#6b4a40' },
          { fill: '#a8c4d4', stroke: '#3a5568' },
          { fill: '#d0bdd4', stroke: '#5a465c' },
          { fill: '#b5ceb8', stroke: '#3f5c42' },
          { fill: '#dcb8c4', stroke: '#6b4555' },
          { fill: '#e4c9a8', stroke: '#6b5030' },
        ];
        /* Progress van is always EOQ green — never drawn from the passer palette */
        this.progressVanColors = [
          { fill: '#ffffff', stroke: '#3a6758' },
          { fill: '#dceee6', stroke: '#2f5a4a' },
          { fill: '#b5ceb8', stroke: '#3f5c42' },
        ];

        this.bubbleAssets = {
          leftInside: this.dataset.bubbleLeftInside || '',
          leftOut: this.dataset.bubbleLeftOut || '',
          rightInside: this.dataset.bubbleRightInside || '',
          rightOut: this.dataset.bubbleRightOut || '',
        };

        this.bubblePhrases = this.parseBubblePhrases('phrases', [
          'Chuck a bit more in and I ship free',
        ]);
        this.bubblePhrasesNear = this.parseBubblePhrases('phrasesNear', [
          'So close I can taste free shipping',
        ]);
        this.bubblePhrasesUnlocked = this.parseBubblePhrases('phrasesUnlocked', [
          'Beauty, free shipping is locked in',
        ]);
        this.bubblePhrasesPasser = this.parseBubblePhrases('phrasesPasser', [
          'There goes another delivery..',
          'Someone else just scored a free run',
          'Look at that legend, already rolling',
          'Mate just flew past, job done',
          'Another van off to the burbs',
          'There goes a happy customer',
          'Ripper, someone else is sorted',
          'That courier looks smug',
          'Beep beep, traffic on my kerb',
          'Another drop off, good on ya',
          'Watch it, busy road today',
          'Blimey',
          'Struth, that bloke was speeding',
          'You beauty',
          'Was that a charter boat?',
          'Crikey, that was quick',
          'Off to the next suburb already',
          'Someone just unlocked the easy run',
          "That van's got places to be",
          'Keep left, busy courier coming through',
          'Another happy drop on the board',
          "Looks like free shipping's catching on",
          'Whoa, nearly clipped my mirrors',
          'Classic peak-hour dash',
          "They're making me look slow",
          'Oi, that was %name% from the depot',
          'Reckon that was %name% from the depot',
          'Was that %name% from the depot?',
          '%name% from the depot just flew past',
          'Look out, %name% from the depot on the move',
          "%name% from the depot's having a ripper run",
          'That was %name% from the depot, fair dinkum',
          '%name% from the depot just scored another drop',
          "%name% from the depot's tearing up the kerb",
          '%name% from the depot, you legend',
          '%name% from the depot just beeped past',
          "%name% from the depot's off like a rocket",
          '%name% from the depot, job done mate',
          '%name% from the depot just cleared the border',
          "%name% from the depot's already halfway there",
          'Spot %name%? That’s depot pedigree',
          'Give %name% a wave from the kerb',
          "%name%'s nicked another free run",
          '%name% must’ve unlocked early',
          "%name%'s flying, absolute unit",
          'Heard %name% got the morning route',
          "That’s %name%’s second pass today",
          'Tell %name% I want their roster',
          '%name% just smoked the border',
          "%name%'s living the free-shipping dream",
          'There goes another one of ours',
          "That one's off to %place%",
          'That was %name% off to %place%',
          "We've had to deliver to %remote% before",
          "%name%'s bound for %place%",
          'Drop off in %place% by lunch',
          'Long haul to %remote% that one',
          'Next stop %place%',
          '%place% run looking sweet',
          "Heard %remote% is on today's sheet",
          'Straight through to %place%',
          'Who ordered from %remote%?',
          '%name% chasing a %place% drop',
          'Bit of a trek to %remote%',
          'Coast run to %place%',
          'Outback job to %remote%',
        ]);
        this.passerPlaces = this.parseBubblePhrases('passerPlaces', [
          'Bondi',
          'Surfers',
          'Broome',
          'Alice Springs',
          'Byron Bay',
          'Fremantle',
          'Hobart',
          'Cairns',
          'Geelong',
          'Ballarat',
          'Toowoomba',
          'Wagga Wagga',
          'Mildura',
          'Darwin',
          'Noosa',
          'Margaret River',
          'Kangaroo Island',
          'Port Macquarie',
          'Wollongong',
          'Newcastle',
          'Townsville',
          'Bendigo',
          'Shepparton',
          'Albury',
          'Launceston',
          'Coffs Harbour',
          'Parramatta',
          'Footscray',
          'Fortitude Valley',
        ]);
        this.passerRemotes = this.parseBubblePhrases('passerRemotes', [
          'Uluru',
          'Kalgoorlie',
          'Broken Hill',
          'Mount Isa',
          'Coober Pedy',
          'Birdsville',
          'Kununurra',
          'Nhulunbuy',
          'Exmouth',
          'Longreach',
          'Charleville',
          'Bourke',
          'Cobar',
          'Lightning Ridge',
          'Carnarvon',
          'Port Hedland',
          'Newman',
          'Tennant Creek',
          'Katherine',
          'Weipa',
        ]);
        this.driverNamePool = this.parseBubblePhrases('passerNames', [
          'Dave',
          'Shazza',
          'Bazza',
          'Kylie',
          'Bruce',
          'Cheryl',
          'Wayne',
          'Tracey',
          'Dazza',
          'Michelle',
          'Shane',
          'Tania',
          'Gary',
          'Bec',
          'Craig',
        ]);
        this.assignProgressDriver(this.driverNamePool);
        this.collectVanIcons();
        const preload = this.preloadVanIconAssets();
        const preloadBudget = new Promise((resolve) => {
          window.setTimeout(resolve, 1200);
        });
        Promise.race([preload, preloadBudget]).finally(() => {
          this.assignProgressVanLook();
          this.revealProgressVan();
        });
        this.bubblePhraseIndex = -1;
        this.bubblePhraseSet = 'early';
        this.passerPhraseIndex = -1;
        this.progressPercent = Number(this.getAttribute('aria-valuenow') || 0);
        this.threshold = Number(this.dataset.threshold || 0);
        this.currency = this.dataset.currency || 'AUD';
        this.locale = this.dataset.locale || 'en-AU';
        this.lastTotalPrice = null;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.pointerX = null;
        this.pointerY = null;
        this.leaveTimer = null;
        this.hoverPinned = false;
        this.progressAnimating = false;
        this.progressAnimFallback = null;
        this.rumbleTimer = null;
        this.nudgeTimer = null;
        this.rollbackTimer = null;
        this.passerTimer = null;
        this.passerReverseTimer = null;
        this.passerKickoffTimer = null;
        this.passerPassCueTimer = null;
        this.passerReversePassCueTimer = null;
        this.passerBubbleTimer = null;
        this.passerBubbleOpen = false;
        this.introTimer = null;
        this.vanMotionBusy = false;

        this.lastTotalPrice = this.hasAttribute('data-initial-total')
          ? Number(this.dataset.initialTotal)
          : 0;
        this.ufoFreeShipGranted = this.hasAttribute('data-ufo-free-ship');

        if (!this._handlersBound) {
          this.onCartUpdate = this.onCartUpdate.bind(this);
          this.onGoalEnter = this.onGoalEnter.bind(this);
          this.onGoalLeave = this.onGoalLeave.bind(this);
          this.onPointerMove = this.onPointerMove.bind(this);
          this.layoutBubble = this.layoutBubble.bind(this);
          this.onGoalTransitionEnd = this.onGoalTransitionEnd.bind(this);
          this.onVanRumbleEnd = this.onVanRumbleEnd.bind(this);
          this.onVanNudgeEnd = this.onVanNudgeEnd.bind(this);
          this.onVanRollbackEnd = this.onVanRollbackEnd.bind(this);
          this.onPasserEnd = this.onPasserEnd.bind(this);
          this.onPasserReverseEnd = this.onPasserReverseEnd.bind(this);
          this.onUfoLanded = this.onUfoLanded.bind(this);
          this.onUfoFreeShipGranted = this.onUfoFreeShipGranted.bind(this);
          this.onVisibilityChange = this.onVisibilityChange.bind(this);
          this.onResize = this.onResize.bind(this);
          this._handlersBound = true;
        }

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate);
        }

        this.setupInteractions();
        window.addEventListener('gma:ufo-landed', this.onUfoLanded);
        window.addEventListener('gma:ufo-free-ship-granted', this.onUfoFreeShipGranted);
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        this.setupViewportObserver();
        this.layoutBubble({ pickVariant: true, randomTilt: false });
        this.syncIdleMotion();
        this.scheduleDriverIntro();
        if (this.ufoFreeShipGranted) {
          this.render(this.lastTotalPrice || 0);
        }
        this.refresh();
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.classList.add('is-positioned');
          });
        });
        this.setAttribute('data-gma-free-shipping-ready', '');
      }

      disconnectedCallback() {
        this.teardownInteractions();
        this.classList.remove('is-positioned');
        this.removeAttribute('data-gma-free-shipping-ready');
      }

      setupInteractions() {
        if (!this.goalEl || this._interactionsBound) return;
        this._interactionsBound = true;

        this.goalEl.addEventListener('pointerenter', this.onGoalEnter);
        this.goalEl.addEventListener('pointerleave', this.onGoalLeave);
        this.goalEl.addEventListener('transitionend', this.onGoalTransitionEnd);
        window.addEventListener('pointermove', this.onPointerMove, { passive: true });
        window.addEventListener('resize', this.onResize, { passive: true });
      }

      teardownInteractions() {
        this.stopIdleMotion();
        clearTimeout(this.leaveTimer);
        clearTimeout(this.progressAnimFallback);
        clearTimeout(this.ufoDriveFallback);
        clearTimeout(this.ufoFadeThenDriveTimer);
        clearTimeout(this.resizeTimer);
        if (this.pointerMoveRaf) {
          cancelAnimationFrame(this.pointerMoveRaf);
          this.pointerMoveRaf = null;
        }
        this.teardownViewportObserver();
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        this.progressAnimating = false;
        this.ufoDrivePending = false;
        this.classList.remove('is-ufo-driving');
        window.removeEventListener('gma:ufo-landed', this.onUfoLanded);
        window.removeEventListener('gma:ufo-free-ship-granted', this.onUfoFreeShipGranted);
        if (typeof this.unsubscribe === 'function') {
          this.unsubscribe();
          this.unsubscribe = null;
        }
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('resize', this.onResize);
        if (this.goalEl) {
          this.goalEl.removeEventListener('pointerenter', this.onGoalEnter);
          this.goalEl.removeEventListener('pointerleave', this.onGoalLeave);
          this.goalEl.removeEventListener('transitionend', this.onGoalTransitionEnd);
        }
        this._interactionsBound = false;
        this.hoverPinned = false;
        this.classList.remove('is-bubble-open');
        this.goalEl?.classList.remove('is-hover');
      }

      setupViewportObserver() {
        this.teardownViewportObserver();
        if (typeof IntersectionObserver !== 'function') {
          this.inViewport = true;
          return;
        }
        this.inViewport = false;
        this.viewportObserver = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            this.inViewport = Boolean(entry?.isIntersecting);
            this.syncIdleMotion();
          },
          { root: null, rootMargin: '80px 0px', threshold: 0 }
        );
        this.viewportObserver.observe(this);
      }

      teardownViewportObserver() {
        this.viewportObserver?.disconnect();
        this.viewportObserver = null;
      }

      onVisibilityChange() {
        this.syncIdleMotion();
      }

      /** Pause decorative timers when the tab is hidden or the van is off-screen (INP hygiene). */
      syncIdleMotion() {
        if (document.hidden || this.inViewport === false) {
          this.stopIdleMotion();
          return;
        }
        this.startIdleMotion();
      }

      onResize() {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          this.layoutBubble({ pickVariant: false, randomTilt: false });
        }, 120);
      }

      vanMotionEl() {
        return this.goalEl?.querySelector('svg, .icon') || null;
      }

      randMs(min, max) {
        return Math.round(min + Math.random() * (max - min));
      }

      startIdleMotion() {
        this.stopIdleMotion();
        if (this.reduceMotion || !this.goalEl) return;
        this.scheduleRumble();
        this.scheduleNudge();
        this.scheduleRollback();
        this.schedulePasserKickoff();
      }

      stopIdleMotion() {
        clearTimeout(this.rumbleTimer);
        clearTimeout(this.nudgeTimer);
        clearTimeout(this.rollbackTimer);
        clearTimeout(this.passerTimer);
        clearTimeout(this.passerReverseTimer);
        clearTimeout(this.passerKickoffTimer);
        clearTimeout(this.passerPassCueTimer);
        clearTimeout(this.passerReversePassCueTimer);
        clearTimeout(this.passerBubbleTimer);
        clearTimeout(this.introTimer);
        this.rumbleTimer = null;
        this.nudgeTimer = null;
        this.rollbackTimer = null;
        this.passerTimer = null;
        this.passerReverseTimer = null;
        this.passerKickoffTimer = null;
        this.passerPassCueTimer = null;
        this.passerReversePassCueTimer = null;
        this.passerBubbleTimer = null;
        this.introTimer = null;
        this.passerBubbleOpen = false;
        this.vanMotionBusy = false;
        const icon = this.vanMotionEl();
        if (icon) {
          icon.classList.remove('is-rumbling', 'is-nudging', 'is-rolling');
          icon.removeEventListener('animationend', this.onVanRumbleEnd);
          icon.removeEventListener('animationend', this.onVanNudgeEnd);
          icon.removeEventListener('animationend', this.onVanRollbackEnd);
          icon.style.removeProperty('--gma-van-rumble-ms');
          icon.style.removeProperty('--gma-van-nudge-ms');
          icon.style.removeProperty('--gma-van-rollback-ms');
        }
        this.resetPasserEl(this.passerEl, this.onPasserEnd);
        this.resetPasserEl(this.passerReverseEl, this.onPasserReverseEnd);
      }

      resetPasserEl(el, endHandler) {
        if (!el) return;
        el.classList.remove('is-passing');
        el.removeEventListener('animationend', endHandler);
        el.style.removeProperty('--gma-passer-ms');
        el.style.removeProperty('--gma-passer-fill');
        el.style.removeProperty('--gma-passer-stroke');
        el.style.removeProperty('--gma-passer-near');
      }

      clearVanMotionClasses(icon) {
        icon.classList.remove('is-rumbling', 'is-nudging', 'is-rolling');
      }

      scheduleRumble() {
        clearTimeout(this.rumbleTimer);
        if (this.reduceMotion || !this.isConnected) return;
        this.rumbleTimer = setTimeout(() => this.playRumble(), this.randMs(8000, 60000));
      }

      scheduleNudge() {
        clearTimeout(this.nudgeTimer);
        if (this.reduceMotion || !this.isConnected) return;
        this.nudgeTimer = setTimeout(() => this.playNudge(), this.randMs(14000, 60000));
      }

      scheduleRollback() {
        clearTimeout(this.rollbackTimer);
        if (this.reduceMotion || !this.isConnected) return;
        this.rollbackTimer = setTimeout(() => this.playRollback(), this.randMs(20000, 60000));
      }

      playRumble() {
        const icon = this.vanMotionEl();
        if (!icon || !this.isConnected) {
          this.scheduleRumble();
          return;
        }
        if (this.vanMotionBusy || this.goalEl?.classList.contains('is-hover')) {
          this.scheduleRumble();
          return;
        }

        this.vanMotionBusy = true;
        icon.style.setProperty('--gma-van-rumble-ms', `${this.randMs(320, 520)}ms`);
        this.clearVanMotionClasses(icon);
        void icon.offsetWidth;
        icon.addEventListener('animationend', this.onVanRumbleEnd);
        icon.classList.add('is-rumbling');
      }

      onVanRumbleEnd(event) {
        if (event.animationName !== 'gma-free-shipping-rumble') return;
        const icon = this.vanMotionEl();
        icon?.removeEventListener('animationend', this.onVanRumbleEnd);
        icon?.classList.remove('is-rumbling');
        this.vanMotionBusy = false;
        this.scheduleRumble();
      }

      playNudge() {
        const icon = this.vanMotionEl();
        if (!icon || !this.isConnected) {
          this.scheduleNudge();
          return;
        }
        if (this.vanMotionBusy || this.goalEl?.classList.contains('is-hover')) {
          this.scheduleNudge();
          return;
        }

        this.vanMotionBusy = true;
        icon.style.setProperty('--gma-van-nudge-ms', `${this.randMs(480, 780)}ms`);
        this.clearVanMotionClasses(icon);
        void icon.offsetWidth;
        icon.addEventListener('animationend', this.onVanNudgeEnd);
        icon.classList.add('is-nudging');
      }

      onVanNudgeEnd(event) {
        if (event.animationName !== 'gma-free-shipping-nudge') return;
        const icon = this.vanMotionEl();
        icon?.removeEventListener('animationend', this.onVanNudgeEnd);
        icon?.classList.remove('is-nudging');
        this.vanMotionBusy = false;
        this.scheduleNudge();
      }

      playRollback() {
        const icon = this.vanMotionEl();
        if (!icon || !this.isConnected) {
          this.scheduleRollback();
          return;
        }
        if (this.vanMotionBusy || this.goalEl?.classList.contains('is-hover')) {
          this.scheduleRollback();
          return;
        }

        this.vanMotionBusy = true;
        icon.style.setProperty('--gma-van-rollback-ms', `${this.randMs(480, 780)}ms`);
        this.clearVanMotionClasses(icon);
        void icon.offsetWidth;
        icon.addEventListener('animationend', this.onVanRollbackEnd);
        icon.classList.add('is-rolling');
      }

      onVanRollbackEnd(event) {
        if (event.animationName !== 'gma-free-shipping-rollback') return;
        const icon = this.vanMotionEl();
        icon?.removeEventListener('animationend', this.onVanRollbackEnd);
        icon?.classList.remove('is-rolling');
        this.vanMotionBusy = false;
        this.scheduleRollback();
      }

      /** Guarantee at least one passer between 45–60s after load, then resume normal cadence. */
      schedulePasserKickoff() {
        clearTimeout(this.passerKickoffTimer);
        if (this.reduceMotion || !this.isConnected) return;
        if (!this.passerEl && !this.passerReverseEl) return;
        this.passerKickoffTimer = setTimeout(
          () => this.playPasserKickoff(),
          this.randMs(45000, 60000)
        );
      }

      playPasserKickoff() {
        if (!this.isConnected || this.reduceMotion) return;
        const canForward = Boolean(this.passerEl);
        const canReverse = Boolean(this.passerReverseEl);
        const useReverse =
          canReverse && (!canForward || Math.random() < 0.5);

        if (useReverse) {
          this.playPasserReverse();
          this.schedulePasser();
          if (canForward && Math.random() < 0.37) {
            this.schedulePasserSoon();
          }
        } else {
          this.playPasser();
          this.schedulePasserReverse();
          if (canReverse && Math.random() < 0.37) {
            this.schedulePasserReverseSoon();
          }
        }
      }

      /** Normal cadence, lightly biased so both directions meet a bit more often. */
      passerGapMs() {
        const gap =
          Math.random() < 0.32
            ? this.randMs(24000, 114000)
            : this.randMs(38000, 342000);
        return gap;
      }

      schedulePasser() {
        clearTimeout(this.passerTimer);
        if (this.reduceMotion || !this.isConnected || !this.passerEl) return;
        this.passerTimer = setTimeout(() => this.playPasser(), this.passerGapMs());
      }

      schedulePasserReverse() {
        clearTimeout(this.passerReverseTimer);
        if (this.reduceMotion || !this.isConnected || !this.passerReverseEl) return;
        this.passerReverseTimer = setTimeout(
          () => this.playPasserReverse(),
          this.passerGapMs()
        );
      }

      /** Occasional near-term companion pass for a dual-van moment. */
      schedulePasserSoon() {
        clearTimeout(this.passerTimer);
        if (this.reduceMotion || !this.isConnected || !this.passerEl) return;
        this.passerTimer = setTimeout(() => this.playPasser(), this.randMs(6000, 16000));
      }

      schedulePasserReverseSoon() {
        clearTimeout(this.passerReverseTimer);
        if (this.reduceMotion || !this.isConnected || !this.passerReverseEl) return;
        this.passerReverseTimer = setTimeout(
          () => this.playPasserReverse(),
          this.randMs(6000, 16000)
        );
      }

      playPasser() {
        this.runPasser(this.passerEl, {
          onEnd: this.onPasserEnd,
          reschedule: () => this.schedulePasser(),
        });
      }

      playPasserReverse() {
        this.runPasser(this.passerReverseEl, {
          onEnd: this.onPasserReverseEnd,
          reschedule: () => this.schedulePasserReverse(),
        });
      }

      runPasser(el, { onEnd, reschedule }) {
        if (!el || !this.isConnected) {
          reschedule();
          return;
        }
        if (this.reduceMotion) return;

        const durationMs = this.randMs(3600, 8000);
        const swatch = this.pickPasserSwatch();
        this.applyVanIcon(el, this.randomPasserIconKey());
        el.style.setProperty('--gma-passer-fill', swatch.fill);
        el.style.setProperty('--gma-passer-stroke', swatch.stroke);
        el.style.color = swatch.fill;
        el.style.setProperty('--gma-passer-ms', `${durationMs}ms`);
        el.style.setProperty('--gma-passer-near', `${this.passerNearPercent()}%`);
        el.classList.remove('is-passing');
        void el.offsetWidth;
        el.addEventListener('animationend', onEnd);
        el.classList.add('is-passing');
        this.schedulePasserPassCue(el, durationMs);
      }

      /** Random passer colour — never the progress van’s session swatch. */
      pickPasserSwatch() {
        const colours = this.passerColors?.length
          ? this.passerColors
          : [{ fill: '#ffffff', stroke: '#1f4d3d' }];
        const pool = colours.filter(
          (c) => c.fill !== this.progressVanFill || c.stroke !== this.progressVanStroke
        );
        const choices = pool.length ? pool : colours;
        return choices[Math.floor(Math.random() * choices.length)];
      }

      /**
       * Cue the driver aside slightly after the passer crosses the progress van
       * (keyframes meet at ~40% — passer may still be in view on the exit).
       */
      schedulePasserPassCue(el, durationMs) {
        const isReverse = el === this.passerReverseEl;
        const key = isReverse ? 'passerReversePassCueTimer' : 'passerPassCueTimer';
        clearTimeout(this[key]);
        const passAt = Math.round(durationMs * 0.4) + this.randMs(180, 360);
        this[key] = setTimeout(() => {
          this[key] = null;
          this.maybeShowPasserBubble();
        }, passAt);
      }

      /** Progress-van centre as % of the host width — slowdown target for the passer. */
      passerNearPercent() {
        const host = this.getBoundingClientRect();
        if (!host.width || !this.goalEl) {
          return Math.min(88, Math.max(12, this.progressPercent || 40));
        }
        const goal = this.goalEl.getBoundingClientRect();
        const pct = ((goal.left + goal.width / 2 - host.left) / host.width) * 100;
        return Math.min(88, Math.max(12, pct));
      }

      onPasserEnd(event) {
        if (event.animationName !== 'gma-free-shipping-pass') return;
        this.passerEl?.removeEventListener('animationend', this.onPasserEnd);
        this.passerEl?.classList.remove('is-passing');
        this.schedulePasser();
      }

      onPasserReverseEnd(event) {
        if (event.animationName !== 'gma-free-shipping-pass-reverse') return;
        this.passerReverseEl?.removeEventListener('animationend', this.onPasserReverseEnd);
        this.passerReverseEl?.classList.remove('is-passing');
        this.schedulePasserReverse();
      }

      maybeShowPasserBubble() {
        if (!this.bubbleTextEl) return;
        // Skip if a bubble is already open (hover or another passer aside)
        if (this.classList.contains('is-bubble-open') || this.hoverPinned || this.passerBubbleOpen) {
          return;
        }
        // Occasionally stay quiet when a van goes by
        if (Math.random() < 0.28) return;

        clearTimeout(this.passerBubbleTimer);
        this.passerBubbleOpen = true;
        this.bubbleTextEl.textContent = this.nextPasserPhrase();
        this.layoutBubble({ pickVariant: true, randomTilt: true });
        this.setBubbleOpen(true);

        this.passerBubbleTimer = setTimeout(() => {
          this.passerBubbleOpen = false;
          if (this.hoverPinned || this.isPointerNearGoal()) return;
          this.setBubbleOpen(false);
        }, 3400);
      }

      /**
       * Pick one Aussie name for the progress van for this browser session.
       * That name is excluded from passer-van name fills.
       */
      assignProgressDriver(allNames) {
        const names = allNames?.length ? allNames : ['Dave'];
        const key = 'gma-free-shipping-driver';
        let driver = null;
        try {
          driver = sessionStorage.getItem(key);
        } catch (_) {
          /* private mode / blocked storage */
        }
        if (!driver || !names.includes(driver)) {
          driver = names[Math.floor(Math.random() * names.length)];
          try {
            sessionStorage.setItem(key, driver);
          } catch (_) {
            /* ignore */
          }
        }
        this.progressDriverName = driver;
        this.passerNames = names.filter((name) => name !== driver);
        this.dataset.progressDriver = driver;
      }

      collectVanIcons() {
        this.vanIcons = {};
        const bank = this.querySelector('template[data-gma-van-icons]');
        const nodes = bank?.content?.querySelectorAll('[data-van-icon]') || [];
        nodes.forEach((node) => {
          const key = node.getAttribute('data-van-icon');
          if (key) this.vanIcons[key] = node.innerHTML.trim();
        });
        // Passer pool from data-van-icon-keys only (excludes progress mdi-van-utility)
        const passerKeys = (this.dataset.vanIconKeys || '')
          .split('|')
          .map((k) => k.trim())
          .filter((k) => k && this.vanIcons[k]);
        this.vanIconKeys = passerKeys.length ? passerKeys : Object.keys(this.vanIcons);
      }

      /** Warm CDN cache and fill any missing icons from asset URLs. */
      preloadVanIconAssets() {
        const urls = (this.dataset.vanIconUrls || '')
          .split('|')
          .map((u) => u.trim())
          .filter(Boolean);
        const keys = (this.dataset.vanIconKeys || '')
          .split('|')
          .map((k) => k.trim())
          .filter(Boolean);
        if (!urls.length) return Promise.resolve();

        return Promise.all(
          urls.map((url, index) =>
            fetch(url, { credentials: 'same-origin', cache: 'force-cache' })
              .then((res) => (res.ok ? res.text() : ''))
              .then((svg) => {
                const key = keys[index];
                if (!key || !svg || !svg.includes('<svg')) return;
                const normalized = svg
                  .replace(/\s(width|height)="1em"/g, '')
                  .replace(/<svg\b/, '<svg class="icon" aria-hidden="true"');
                if (!this.vanIcons[key]) this.vanIcons[key] = normalized;
              })
              .catch(() => {})
          )
        ).then(() => {
          const passerKeys = (this.dataset.vanIconKeys || '')
            .split('|')
            .map((k) => k.trim())
            .filter((k) => k && this.vanIcons[k]);
          this.vanIconKeys = passerKeys.length ? passerKeys : Object.keys(this.vanIcons);
        });
      }

      revealProgressVan() {
        if (!this.goalEl) return;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.goalEl?.classList.add('is-van-ready');
          });
        });
      }

      /**
       * Progress van always uses mdi-van-utility + EOQ green colours.
       * Passers keep picking randomly from the icon/colour pools.
       */
      assignProgressVanLook() {
        const colours = this.progressVanColors?.length
          ? this.progressVanColors
          : [{ fill: '#ffffff', stroke: '#3a6758' }];
        const iconKey = 'mdi-van-utility';

        let fill = null;
        let stroke = null;
        try {
          fill = sessionStorage.getItem('gma-free-shipping-van-fill');
          stroke = sessionStorage.getItem('gma-free-shipping-van-stroke');
        } catch (_) {
          /* ignore */
        }

        const colourOk = colours.some((c) => c.fill === fill && c.stroke === stroke);
        if (!colourOk) {
          const swatch = colours[Math.floor(Math.random() * colours.length)];
          fill = swatch.fill;
          stroke = swatch.stroke;
        }
        try {
          sessionStorage.setItem('gma-free-shipping-van-icon', iconKey);
          sessionStorage.setItem('gma-free-shipping-van-fill', fill);
          sessionStorage.setItem('gma-free-shipping-van-stroke', stroke);
        } catch (_) {
          /* ignore */
        }

        this.progressVanIcon = iconKey;
        this.progressVanFill = fill;
        this.progressVanStroke = stroke;
        this.dataset.progressVanIcon = iconKey;
        // Scope to the goal only — do not inherit onto passers
        this.style.removeProperty('--gma-van-color');
        this.style.removeProperty('--gma-van-stroke');
        if (this.goalEl) {
          this.goalEl.style.setProperty('--gma-van-color', fill);
          this.goalEl.style.setProperty('--gma-van-stroke', stroke);
          this.goalEl.style.color = fill;
        }
        this.applyVanIcon(this.goalEl, iconKey);
      }

      applyVanIcon(el, iconKey) {
        if (!el || !iconKey) return;
        const html = this.vanIcons?.[iconKey];
        if (!html) return;
        el.innerHTML = html;
        const svg = el.querySelector('svg');
        if (!svg) return;
        svg.setAttribute('preserveAspectRatio', 'xMidYMax meet');
        svg.removeAttribute('width');
        svg.removeAttribute('height');
        // Tight ink viewBoxes — also guards against stale Liquid inline_asset_content.
        const viewBoxes = {
          'mdi-van-utility': '0.56 6.5 22.88 15',
          'lucide-van': '0 4 24 18',
          'material-delivery-truck-speed': '0.16 3.66 23.18 16.68',
          'mdi-truck': '0.67 3.67 22.66 16.66',
          'ph-truck-fill': '12.4 52.4 247.2 175.26',
          'ph-truck-trailer-fill': '-3.84 36.16 263.68 183.74',
          'streamline-cyber-delivery-truck': '-0.5 4.5 25 18.5',
          'zmdi-truck': '-7.04 13.96 483.07 356.07',
        };
        if (viewBoxes[iconKey]) {
          svg.setAttribute('viewBox', viewBoxes[iconKey]);
        }
      }

      randomPasserIconKey() {
        const keys = this.vanIconKeys?.length ? this.vanIconKeys : ['lucide-van'];
        return keys[Math.floor(Math.random() * keys.length)];
      }

      scheduleDriverIntro() {
        clearTimeout(this.introTimer);
        if (!this.progressDriverName || this.hasDriverIntroduced()) return;
        this.introDeadline = Date.now() + 10000;
        this.introTimer = setTimeout(() => this.maybeShowDriverIntro(), this.randMs(5000, 10000));
      }

      hasDriverIntroduced() {
        try {
          return sessionStorage.getItem('gma-free-shipping-driver-intro') === '1';
        } catch (_) {
          return Boolean(this._driverIntroducedMemory);
        }
      }

      markDriverIntroduced() {
        this._driverIntroducedMemory = true;
        try {
          sessionStorage.setItem('gma-free-shipping-driver-intro', '1');
        } catch (_) {
          /* ignore */
        }
      }

      maybeShowDriverIntro() {
        if (!this.isConnected || !this.bubbleTextEl || !this.progressDriverName) return;
        if (this.hasDriverIntroduced()) return;

        if (this.classList.contains('is-bubble-open') || this.hoverPinned || this.passerBubbleOpen) {
          if (Date.now() < this.introDeadline) {
            this.introTimer = setTimeout(() => this.maybeShowDriverIntro(), 800);
            return;
          }
          // Past the 10s window — still introduce once if we can steal the bubble
        }

        this.markDriverIntroduced();
        this.playAutoBubble(this.driverIntroPhrase(), 5200, () => {
          if (!this.isConnected || this.hoverPinned || this.isPointerNearGoal()) {
            this.passerBubbleOpen = false;
            return;
          }
          this.playAutoBubble(this.driverPurposePhrase(), 5600, () => {
            this.passerBubbleOpen = false;
            if (this.hoverPinned || this.isPointerNearGoal()) return;
            this.setBubbleOpen(false);
          });
        });
      }

      playAutoBubble(text, holdMs, onDone) {
        clearTimeout(this.passerBubbleTimer);
        this.passerBubbleOpen = true;
        this.bubbleTextEl.textContent = text;
        this.layoutBubble({ pickVariant: true, randomTilt: true });
        this.setBubbleOpen(true);
        this.passerBubbleTimer = setTimeout(() => {
          if (typeof onDone === 'function') onDone();
        }, holdMs);
      }

      driverIntroPhrase() {
        const templates = [
          "G'day, I'm %driver% from the depot",
          "How ya goin, %driver% here",
          "%driver% on the free-shipping run today",
          "Name's %driver%. I'll get you there",
          "Hiya, %driver% behind the wheel",
        ];
        const template = templates[Math.floor(Math.random() * templates.length)];
        return template.replace(/%driver%/g, this.progressDriverName);
      }

      /** Short follow-up after the name intro — why this van is here. */
      driverPurposePhrase() {
        const lines = [
          'I show how close you are to free shipping',
          'Here to track your free-shipping run',
          'I move as you near free shipping',
          "Free shipping progress. That's me",
          'Watch me for free-shipping progress',
        ];
        return lines[Math.floor(Math.random() * lines.length)];
      }

      onUfoLanded() {
        if (!this.isConnected || !this.bubbleTextEl) return;
        this.showUfoDisbeliefBubble();
      }

      onUfoFreeShipGranted() {
        if (!this.isConnected) return;
        this.ufoFreeShipGranted = true;
        this.setAttribute('data-ufo-free-ship', '');

        const startDrive = () => {
          if (!this.isConnected) return;
          this.syncFootnote(this.lastTotalPrice || 0);
          this.classList.add('gma-free-shipping--qualified');
          this.driveVanToHundredThenCelebrate();
          // Re-sync from cart so state follows attributes/codes (clears after checkout)
          this.refresh();
        };

        // Fade out hello / disbelief first (same bubble fade as welcome messages)
        clearTimeout(this.passerBubbleTimer);
        clearTimeout(this.introTimer);
        clearTimeout(this.ufoDriveFallback);
        clearTimeout(this.ufoFadeThenDriveTimer);
        this.passerBubbleOpen = false;
        this.hoverPinned = false;

        if (this.classList.contains('is-bubble-open')) {
          this.setBubbleOpen(false);
          this.ufoFadeThenDriveTimer = setTimeout(startDrive, 360);
        } else {
          startDrive();
        }
      }

      /**
       * Animate the progress van to 100%, then show the UFO celebration bubble.
       * Avoids the bubble snapping mid-travel.
       */
      driveVanToHundredThenCelebrate() {
        const from = Number(this.progressPercent || 0);
        this.ufoDrivePending = true;
        this.classList.add('is-ufo-driving');

        const finish = () => {
          if (!this.isConnected || !this.ufoDrivePending) return;
          this.ufoDrivePending = false;
          this.progressAnimating = false;
          this.classList.remove('is-ufo-driving');
          this.showUfoCelebrationBubble();
        };

        if (this.reduceMotion || from >= 100) {
          this.setProgress(100, { deferBubble: true });
          finish();
          return;
        }

        this.setProgress(100, { deferBubble: true });

        const onEnd = (event) => {
          if (event.propertyName !== 'left') return;
          this.goalEl?.removeEventListener('transitionend', onEnd);
          clearTimeout(this.ufoDriveFallback);
          finish();
        };

        // Longer drive when farther from 100% (~0.7s–1.25s)
        const durationMs = Math.round(700 + Math.min(55, 100 - from) * 10);
        this.goalEl?.addEventListener('transitionend', onEnd);
        this.ufoDriveFallback = setTimeout(() => {
          this.goalEl?.removeEventListener('transitionend', onEnd);
          finish();
        }, durationMs + 160);
      }

      showUfoCelebrationBubble() {
        if (!this.isConnected || !this.bubbleTextEl) return;
        clearTimeout(this.introTimer);
        const lines = [
          'Beauty, free delivery locked in!',
          'You caught the UFO! Free shipping yours',
          'Alien deal secured. Delivery is on the house',
          'Free delivery activated. Nice catch!',
        ];
        const text = lines[Math.floor(Math.random() * lines.length)];
        // Same hold + fade path as the driver hello / welcome messages
        this.playAutoBubble(text, 5200, () => {
          this.passerBubbleOpen = false;
          if (this.hoverPinned || this.isPointerNearGoal()) return;
          this.setBubbleOpen(false);
        });
      }

      /** Progress driver reacts when the UFO easter egg lands on Add to cart. */
      showUfoDisbeliefBubble() {
        if (!this.bubbleTextEl) return;
        clearTimeout(this.introTimer);
        this.playAutoBubble(this.randomUfoDisbeliefPhrase(), 4800, () => {
          this.passerBubbleOpen = false;
          if (this.hoverPinned || this.isPointerNearGoal()) return;
          this.setBubbleOpen(false);
        });
      }

      randomUfoDisbeliefPhrase() {
        const lines = [
          'Struth, is that a UFO?',
          'Mate... that is a spaceship',
          'No way. Absolute no way.',
          'I am not paid enough for aliens',
          'That thing is landing on the button',
          'Blimey, traffic from space now?',
          'Reckon HQ will believe this?',
          'That is not one of ours',
          'Crikey. Off-world delivery?',
          'I need a cuppa watching this',
          'Is that a drone... or not?',
          'Look at that, hovering right there',
          'Aliens on the Add to cart, fair dinkum',
          'Something weird is parking on my route',
        ];
        return lines[Math.floor(Math.random() * lines.length)];
      }

      nextPasserPhrase() {
        const phrases = this.bubblePhrasesPasser?.length
          ? this.bubblePhrasesPasser
          : ['There goes another delivery..'];
        let index = Math.floor(Math.random() * phrases.length);
        // Avoid immediate repeats when there is more than one saying
        if (phrases.length > 1 && index === this.passerPhraseIndex) {
          index = (index + 1 + Math.floor(Math.random() * (phrases.length - 1))) % phrases.length;
        }
        this.passerPhraseIndex = index;
        return this.fillPasserPlaceholders(phrases[index]);
      }

      /** Fill `%name%` / `%place%` / `%remote%` tokens in passer asides. */
      fillPasserPlaceholders(phrase) {
        let out = phrase;
        if (out.includes('%name%') && this.passerNames?.length) {
          const name = this.passerNames[Math.floor(Math.random() * this.passerNames.length)];
          out = out.replace(/%name%/g, name);
        }
        if (out.includes('%place%') && this.passerPlaces?.length) {
          const place = this.passerPlaces[Math.floor(Math.random() * this.passerPlaces.length)];
          out = out.replace(/%place%/g, place);
        }
        if (out.includes('%remote%') && this.passerRemotes?.length) {
          const remote = this.passerRemotes[Math.floor(Math.random() * this.passerRemotes.length)];
          out = out.replace(/%remote%/g, remote);
        }
        return out;
      }

      onPointerMove(event) {
        this.pointerX = event.clientX;
        this.pointerY = event.clientY;
        if (this.pointerMoveRaf) return;
        this.pointerMoveRaf = requestAnimationFrame(() => {
          this.pointerMoveRaf = null;
          this.syncHoverFromPointer();
        });
      }

      syncHoverFromPointer() {
        if (!this.goalEl || this.pointerX == null || this.pointerY == null) return;

        const over = this.isPointerNearGoal();
        if (over) {
          clearTimeout(this.leaveTimer);
          clearTimeout(this.passerBubbleTimer);
          this.passerBubbleOpen = false;
          const alreadyOpen = this.hoverPinned;
          this.hoverPinned = true;
          this.setBubbleOpen(true);
          if (!alreadyOpen) {
            this.rotateBubblePhrase();
            this.layoutBubble({ pickVariant: true, randomTilt: true });
          }
          return;
        }

        this.scheduleBubbleClose({ allowNearReentry: true });
      }

      /**
       * Close after a short grace period.
       * @param {{ allowNearReentry?: boolean }} [opts]
       *   allowNearReentry: when true (pointermove path), geometric near can cancel.
       *   when false (pointerleave path), only a live :hover on the van cancels —
       *   leave-edge coords often still count as "near" and would stick the bubble open.
       */
      scheduleBubbleClose(opts = {}) {
        const allowNearReentry = opts.allowNearReentry !== false;
        if (!this.hoverPinned || this.progressAnimating) return;
        clearTimeout(this.leaveTimer);
        this.leaveTimer = setTimeout(() => {
          if (this.progressAnimating) return;
          const stillOnVan = this.goalEl?.matches(':hover');
          const stillNear = allowNearReentry && this.isPointerNearGoal();
          if (stillOnVan || stillNear) {
            this.setBubbleOpen(true);
            return;
          }
          this.hoverPinned = false;
          if (this.passerBubbleOpen) return;
          this.setBubbleOpen(false);
        }, 140);
      }

      onGoalEnter() {
        clearTimeout(this.leaveTimer);
        clearTimeout(this.passerBubbleTimer);
        this.passerBubbleOpen = false;
        const alreadyOpen = this.hoverPinned;
        this.hoverPinned = true;
        this.setBubbleOpen(true);
        if (!alreadyOpen) {
          this.rotateBubblePhrase();
          this.layoutBubble({ pickVariant: true, randomTilt: true });
        }
      }

      onGoalLeave() {
        // Do not call syncHoverFromPointer here — leave-edge geometry is still "near".
        this.scheduleBubbleClose({ allowNearReentry: false });
      }

      onGoalTransitionEnd(event) {
        if (event.propertyName !== 'left') return;
        // UFO drive owns its own celebration timing
        if (this.ufoDrivePending) return;
        clearTimeout(this.progressAnimFallback);
        this.progressAnimating = false;
        this.layoutBubble({ pickVariant: false, randomTilt: false });
        this.syncHoverFromPointer();
      }

      setBubbleOpen(open) {
        this.goalEl?.classList.toggle('is-hover', open);
        this.classList.toggle('is-bubble-open', open);
      }

      isPointerNearGoal() {
        if (!this.goalEl || this.pointerX == null || this.pointerY == null) return false;
        const rect = this.goalEl.getBoundingClientRect();
        if (!rect.width || !rect.height) return false;
        const cx = rect.left + rect.width / 2;
        const cy = rect.top + rect.height / 2;
        // Match the ::before hit pad; floor so the compact van stays easy to open
        const hitR = Math.max(26, Math.max(rect.width, rect.height) * 1.25);
        return Math.hypot(this.pointerX - cx, this.pointerY - cy) <= hitR;
      }

      isPointerOverGoal() {
        return this.isPointerNearGoal();
      }

      measureLabelTextRight(labelEl) {
        if (!labelEl) return null;
        for (const node of labelEl.childNodes) {
          if (node.nodeType !== Node.TEXT_NODE) continue;
          if (!node.textContent || !node.textContent.trim()) continue;
          const range = document.createRange();
          range.selectNodeContents(node);
          const rect = range.getBoundingClientRect();
          range.detach?.();
          if (rect.width) return rect.right;
        }
        return labelEl.getBoundingClientRect().left + Math.min(labelEl.offsetWidth * 0.35, 110);
      }

      labelBounds(hostRect) {
        const row = this.closest('.gma-everyday-pricing__row--offer') || this.parentElement;
        const labelEl = row?.querySelector?.('.gma-everyday-pricing__pay-label');
        const priceEl = row?.querySelector?.('.gma-everyday-pricing__price');
        const clear = 12;
        const labelTextRight = this.measureLabelTextRight(labelEl);
        const labelRight =
          labelTextRight != null ? labelTextRight - hostRect.left + clear : clear;
        const priceLeft = priceEl
          ? priceEl.getBoundingClientRect().left - hostRect.left - clear
          : hostRect.width - clear;
        return {
          labelRight,
          priceLeft,
          gap: Math.max(0, priceLeft - labelRight),
        };
      }

      /**
       * Pick static bubble from free-shipping progress so the pointer faces the van:
       *   <=25%  → left outside
       *   >25–<50% → left inside
       *   50–<75% → right inside
       *   >=75%  → right outside
       */
      pickBubbleAsset() {
        const p = Math.min(100, Math.max(0, this.progressPercent));
        if (p <= 25) return this.bubbleAssets.leftOut;
        if (p < 50) return this.bubbleAssets.leftInside;
        if (p < 75) return this.bubbleAssets.rightInside;
        return this.bubbleAssets.rightOut;
      }

      /** Tip X as a fraction of bubble width (from SVG path anchors). */
      bubbleTipRatio() {
        const p = Math.min(100, Math.max(0, this.progressPercent));
        if (p <= 25) return 0.01; // left-out ≈ 2/216
        if (p < 50) return 0.521; // left-inside ≈ 112/215
        if (p < 75) return 0.47; // right-inside ≈ 101/215
        return 0.977; // right-out ≈ 211/216
      }

      randomTilt() {
        // Subtle lean only — never beyond ±2°
        const mag = Math.random() * 2;
        return (Math.random() < 0.5 ? -mag : mag).toFixed(1);
      }

      layoutBubble(options = {}) {
        const pickVariant = options.pickVariant !== false;
        const doTilt = Boolean(options.randomTilt);

        if (!this.bubbleEl || !this.goalEl) return;

        const host = this.getBoundingClientRect();
        if (!host.width || !host.height) return;

        const goalRect = this.goalEl.getBoundingClientRect();
        const vanCx = goalRect.left + goalRect.width / 2 - host.left;
        const bounds = this.labelBounds(host);

        // 70% of the label↔price connector whitespace; height follows SVG
        const bubbleWidth = Math.max(112, bounds.gap * 0.7);
        this.style.setProperty('--gma-bubble-width', `${Math.round(bubbleWidth)}px`);

        // Aim the pointer near the van with horizontal clearance (not stacked on it)
        const p = Math.min(100, Math.max(0, this.progressPercent));
        const tipRatio = this.bubbleTipRatio();
        const tipGap = 22;
        const tipSide = p < 50 ? -1 : 1;
        const tipAimX = vanCx + tipSide * tipGap;
        let left = tipAimX + bubbleWidth * (0.5 - tipRatio);

        const minCenter = bounds.labelRight + bubbleWidth / 2;
        const maxCenter = bounds.priceLeft - bubbleWidth / 2;
        if (minCenter <= maxCenter) {
          left = Math.min(Math.max(left, minCenter), maxCenter);
          // Inside variants: park toward the far side of the gap (tip still faces van)
          if (p > 25 && p < 50) {
            left += (maxCenter - left) * 0.36; // left-inside → right
          } else if (p >= 50 && p < 75) {
            left -= (left - minCenter) * 0.36; // right-inside → left
          }
        } else {
          left = (bounds.labelRight + bounds.priceLeft) / 2;
        }

        this.style.setProperty('--gma-bubble-x', `${Math.round(left)}px`);
        this.style.setProperty('--gma-bubble-y', '0.55rem');

        if (doTilt) {
          this.style.setProperty('--gma-bubble-rotate', `${this.randomTilt()}deg`);
        } else if (!this.style.getPropertyValue('--gma-bubble-rotate')) {
          this.style.setProperty('--gma-bubble-rotate', '0deg');
        }

        if (pickVariant && this.bubbleImg) {
          const src = this.pickBubbleAsset();
          if (src) this.bubbleImg.src = src;
        }
      }

      parseBubblePhrases(datasetKey, fallback) {
        const raw = this.dataset?.[datasetKey] || '';
        const phrases = raw
          .split('|')
          .map((phrase) => phrase.trim())
          .filter(Boolean);
        return phrases.length ? phrases : fallback;
      }

      activeBubblePhraseSet() {
        if (this.progressPercent >= 100) return 'unlocked';
        if (this.progressPercent >= 75) return 'near';
        return 'early';
      }

      activeBubblePhrases() {
        const set = this.activeBubblePhraseSet();
        if (set === 'unlocked') return this.bubblePhrasesUnlocked;
        if (set === 'near') return this.bubblePhrasesNear;
        return this.bubblePhrases;
      }

      rotateBubblePhrase() {
        if (!this.bubbleTextEl) return;
        const phrases = this.activeBubblePhrases();
        if (!phrases.length) return;

        const nextSet = this.activeBubblePhraseSet();
        if (nextSet !== this.bubblePhraseSet) {
          this.bubblePhraseSet = nextSet;
          this.bubblePhraseIndex = -1;
        }

        let index = Math.floor(Math.random() * phrases.length);
        if (phrases.length > 1 && index === this.bubblePhraseIndex) {
          index = (index + 1 + Math.floor(Math.random() * (phrases.length - 1))) % phrases.length;
        }
        this.bubblePhraseIndex = index;
        this.bubbleTextEl.textContent = phrases[index];
      }

      onCartUpdate() {
        this.refresh();
      }

      refresh() {
        if (!this.threshold || this.threshold <= 0) {
          this.syncFootnote(0);
          this.setProgress(0);
          return Promise.resolve();
        }

        return this.fetchCartTotal()
          .then((totalPrice) => {
            this.lastTotalPrice = totalPrice;
            this.render(totalPrice);
          })
          .catch(() => {});
      }

      cartHasUfoCode(cart) {
        const itemCount = Number(cart?.item_count || 0);
        const attr = String(
          cart?.attributes?.gma_ufo_sighting || cart?.attributes?.['gma_ufo_sighting'] || ''
        );
        const hasAttr = /^ufo-sighting-/i.test(attr);

        // After checkout (or cart clear) the cart is empty — drop UFO UI and scrub the attribute.
        // Note: /cart/clear.js keeps attributes; a completed checkout starts a new cart without them.
        if (itemCount <= 0) {
          if (hasAttr) this.clearUfoCartAttribute();
          return false;
        }

        if (hasAttr) {
          return true;
        }

        const codes = Array.isArray(cart?.discount_codes) ? cart.discount_codes : [];
        if (
          codes.some(
            (entry) =>
              entry &&
              entry.applicable !== false &&
              /^ufo-sighting-\d+$/i.test(String(entry.code || ''))
          )
        ) {
          return true;
        }

        const apps = [
          ...(Array.isArray(cart?.cart_level_discount_applications)
            ? cart.cart_level_discount_applications
            : []),
          ...(Array.isArray(cart?.discount_applications) ? cart.discount_applications : []),
        ];
        return apps.some((app) => {
          const title = String(app?.title || '');
          return /^ufo-sighting-\d+$/i.test(title) || /^ufo sighting \d+/i.test(title);
        });
      }

      clearUfoCartAttribute() {
        if (this._clearingUfoAttr) return;
        this._clearingUfoAttr = true;
        const root =
          (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          credentials: 'same-origin',
          body: JSON.stringify({ attributes: { gma_ufo_sighting: '' } }),
        })
          .catch(() => {})
          .finally(() => {
            this._clearingUfoAttr = false;
          });
      }

      async fetchCartTotal() {
        const cartUrl = window.routes?.cart_url ? `${window.routes.cart_url}.js` : '/cart.js';
        const response = await fetch(cartUrl, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        });
        if (!response.ok) throw new Error('Unable to load cart');
        const cart = await response.json();
        // Derive only from the live cart — attributes/codes clear after checkout with a new cart
        this.ufoFreeShipGranted = this.cartHasUfoCode(cart);
        if (this.ufoFreeShipGranted) {
          this.setAttribute('data-ufo-free-ship', '');
          this.ensureUfoCartAttribute(cart);
        } else {
          this.removeAttribute('data-ufo-free-ship');
        }
        return Number(cart.total_price || 0);
      }

      /**
       * Free-shipping discount codes are not Liquid-visible. Persist a cart attribute so
       * SSR shows the UFO footnote/van. Attributes reset automatically on a new cart after checkout.
       */
      ensureUfoCartAttribute(cart) {
        const existing = String(
          cart?.attributes?.gma_ufo_sighting || cart?.attributes?.['gma_ufo_sighting'] || ''
        );
        if (/^ufo-sighting-/i.test(existing)) return;

        const codes = Array.isArray(cart?.discount_codes) ? cart.discount_codes : [];
        const match = codes.find(
          (entry) =>
            entry &&
            entry.applicable !== false &&
            /^ufo-sighting-\d+$/i.test(String(entry.code || ''))
        );
        const code = match ? String(match.code) : '';
        if (!code) return;

        const root =
          (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          credentials: 'same-origin',
          body: JSON.stringify({ attributes: { gma_ufo_sighting: code } }),
        }).catch(() => {});
      }

      formatMoney(cents) {
        const amount = Number(cents || 0) / 100;
        try {
          const formatted = new Intl.NumberFormat(this.locale, {
            style: 'currency',
            currency: this.currency,
            currencyDisplay: 'narrowSymbol',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          }).format(amount);
          return formatted.replace(/([.,]00)(?!\d)/, '');
        } catch (error) {
          return `$${amount % 1 === 0 ? amount.toFixed(0) : amount.toFixed(2)}`;
        }
      }

      footnoteEl() {
        return document.querySelector('[data-gma-shipping-footnote][data-threshold]');
      }

      buildProgressFootnote() {
        const el = this.footnoteEl();
        return (
          el?.dataset.msgProgress ||
          'Shipping $9.95, add more items to your cart for free shipping. Prices incl. GST.'
        );
      }

      syncFootnote(totalPrice) {
        const el = this.footnoteEl();
        if (!el) return;
        const emptyMsg = el.dataset.msgEmpty;
        const qualifiedMsg = el.dataset.msgQualified;
        const taxSuffix = el.dataset.taxSuffix || 'Incl. GST.';

        if (this.ufoFreeShipGranted) {
          el.textContent =
            el.dataset.msgUfoQualified ||
            'Confirmed UFO sighting, free delivery activated. Prices incl. GST';
          return;
        }

        if (!totalPrice || totalPrice <= 0) {
          el.textContent = emptyMsg || taxSuffix;
          return;
        }

        const remaining = Math.max(this.threshold - totalPrice, 0);
        if (remaining === 0) {
          el.textContent = qualifiedMsg || `You've unlocked free shipping on this order. ${taxSuffix}`;
          return;
        }

        el.textContent = this.buildProgressFootnote();
      }

      render(totalPrice) {
        this.syncFootnote(totalPrice);

        if (this.ufoFreeShipGranted) {
          this.classList.add('gma-free-shipping--qualified');
          this.setProgress(100);
          return;
        }

        if (!totalPrice || totalPrice <= 0) {
          this.classList.remove('gma-free-shipping--qualified');
          this.setProgress(0);
          return;
        }

        const remaining = Math.max(this.threshold - totalPrice, 0);
        const qualified = remaining === 0;
        let percentage = Math.round((totalPrice * 100) / this.threshold);
        if (percentage > 100) percentage = 100;
        if (percentage < 0) percentage = 0;

        this.classList.toggle('gma-free-shipping--qualified', qualified);
        this.setProgress(percentage);
      }

      setProgress(percentage, options = {}) {
        const deferBubble = options.deferBubble === true || this.ufoDrivePending === true;
        const wasOpen =
          !deferBubble && (this.hoverPinned || this.goalEl?.classList.contains('is-hover'));
        const prev = this.progressPercent;
        const moved = prev !== percentage;
        this.progressPercent = percentage;
        this.setAttribute('aria-valuenow', String(percentage));
        this.style.setProperty('--gma-free-shipping-progress', String(percentage));

        if (!this.goalEl) return;

        const apply = () => {
          // Only lock hover-close while left is actually transitioning.
          // Same-position updates never fire transitionend and used to stick the bubble open.
          if (moved && !this.reduceMotion) {
            this.progressAnimating = true;
            clearTimeout(this.progressAnimFallback);
            this.progressAnimFallback = setTimeout(() => {
              this.progressAnimating = false;
              this.syncHoverFromPointer();
            }, 600);
          } else {
            this.progressAnimating = false;
          }
          this.goalEl.style.setProperty('--gma-free-shipping-progress', String(percentage));
          if (!deferBubble) {
            this.layoutBubble({ pickVariant: true, randomTilt: false });
            if (wasOpen || this.isPointerOverGoal()) {
              this.hoverPinned = true;
              this.setBubbleOpen(true);
            }
          }
        };

        if (this.reduceMotion) {
          apply();
          return;
        }

        requestAnimationFrame(apply);
      }
    }
  );
}
